export default __webpack_public_path__ + "static/media/factory-sidebar-icon.25f064da.svg";